import React from 'react';

function ModeSelector({ modes, currentMode, onModeChange, disabled }) {
  if (!modes || Object.keys(modes).length === 0) {
    return null; // Don't render if modes aren't loaded
  }

  return (
    <div className="mode-selector-container">
      <label htmlFor="mode-select">Select Role: </label>
      <select 
        id="mode-select" 
        value={currentMode} 
        onChange={(e) => onModeChange(e.target.value)} 
        disabled={disabled}
      >
        {Object.entries(modes).map(([modeKey, modeDetails]) => (
          <option key={modeKey} value={modeKey}>
            {modeDetails.display_name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default ModeSelector;
